import { Link } from 'react-router-dom';
import './section-title.scss';

function SectionTitle(props) {
  // Title Default H2 Tag with Props
  const { tag: HeadingTag = 'h2' } = props;

  return (
    <>
      <div className={`section-title ${props.extraClass || ''}`}>
        <HeadingTag className="title">{props.title}</HeadingTag>
        
        {props?.content && <p>{props.content}</p>}
        {props?.manyContent &&  props.manyContent.map(x=>{
          return(
              <p style={{fontWeight:"300",fontSize:"15px"}}>{x}
              
              </p>
          )
        })}
          {props?.linkName && 
          <p className="feature-timeline-content">
            <Link to={props.link}  className="feature-timeline-content">{props.linkName}</Link>
          </p>
          }
       
      </div>
    </>
  );
}

export default SectionTitle;
